import CtaBand from "../components/CtaBand";
import { IconCheck } from "../components/icons";

const SERVICES = [
  {
    title: "Integrations",
    lead: "Make your systems talk to each other.",
    body: "Most businesses run on a handful of tools that don't quite join up. We build the connections between them — CRMs, accounting, e-commerce, internal databases, third-party APIs — so data flows automatically and stays consistent.",
    points: ["Two-way sync between existing tools", "API and webhook integrations", "Data migration and clean-up", "Monitoring so you know when something breaks"],
    price: "From a fixed-price discovery, then scoped delivery",
  },
  {
    title: "Web applications",
    lead: "Custom software, built to last.",
    body: "When off-the-shelf doesn't fit, we build it. Internal tools that replace spreadsheets and manual process, or customer-facing apps — fast, accessible, and running on infrastructure that scales down to near-zero cost when idle.",
    points: ["Internal dashboards and admin tools", "Customer portals and booking systems", "React + TypeScript on Cloudflare", "Accessible (WCAG) and mobile-first"],
    price: "Scoped per project after a discovery call",
  },
  {
    title: "Automation",
    lead: "Stop doing by hand what a machine should do.",
    body: "The repetitive jobs — exporting reports, chasing approvals, re-keying orders — are where time leaks and mistakes creep in. We automate them with reliable, observable workflows that run on their own and tell you if anything goes wrong.",
    points: ["Scheduled and event-driven workflows", "Document and report generation", "Notifications and approval flows", "Clear logs and failure alerts"],
    price: "Often the fastest payback — priced per workflow",
  },
  {
    title: "Consultancy",
    lead: "A straight answer when the decision is hard to reverse.",
    body: "Sometimes you don't need us to build it — you need someone who's done it before to pressure-test the plan. Architecture reviews, build-or-buy decisions, delivery help for an in-house team that's stretched.",
    points: ["Architecture and technical review", "Build-or-buy and vendor selection", "Delivery and code-review support", "Fractional technical lead"],
    price: "Day rate or short fixed-term engagements",
  },
];

export default function Services() {
  return (
    <>
      <section className="pagehead">
        <div className="container">
          <p className="eyebrow">Services</p>
          <h1 className="display-lg">What we do, and how we price it.</h1>
          <p className="lead">
            Four things, done properly. Every engagement starts with a scoped
            discovery so you know the cost and the plan before we build anything.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          {SERVICES.map((s) => (
            <article className="svc" key={s.title} id={s.title.toLowerCase().split(" ")[0]}>
              <div>
                <h2 className="display-md" style={{ fontStyle: "italic" }}>{s.title}</h2>
                <p style={{ marginTop: 10, color: "var(--teal-deep)", fontWeight: 600 }}>{s.lead}</p>
                <p className="svc__price">{s.price}</p>
              </div>
              <div>
                <p className="lead" style={{ marginBottom: 20 }}>{s.body}</p>
                <ul className="ticks">
                  {s.points.map((p) => (
                    <li key={p}><IconCheck /> {p}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <CtaBand heading="Not sure which one you need?" sub="That's what the discovery call is for. Tell us the problem; we'll tell you the shortest route to fixing it." />
    </>
  );
}
